import {
  Connection,
  ConnectionStatus,
} from 'src/common/store/connection/ConnectionState';

export const isConnectionConnected = (connection: Connection) =>
  connection && connection.status === ConnectionStatus.SUCCESS;
